import { render, staticRenderFns } from "./SalaryList.vue?vue&type=template&id=21d7860a&scoped=true"
import script from "./SalaryList.vue?vue&type=script&lang=js"
export * from "./SalaryList.vue?vue&type=script&lang=js"
import style0 from "./SalaryList.vue?vue&type=style&index=0&id=21d7860a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d7860a",
  null
  
)

export default component.exports